import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppAutoCompleteModule } from './autocomplete';

@NgModule({
  imports: [CommonModule, AppAutoCompleteModule]
})
export class CustomMaterialComponentsModule {}
